/**
 * Satisfy TS compiler that `T[]` and `[T, ...T[]] | []` mean the same thing.
 * (z.tuple is asking for the latter type signature on its arg)
 */
export const fitArrayForTuple = <T>([head, ...tail]: T[]): [T, ...T[]] | [] =>
  typeof head !== 'undefined' ? [head, ...tail] : []
